export default "__VITE_ASSET__DYtnN5QR__"